export default "__VITE_ASSET__CAFtxCA1__"